import { Component, OnInit } from '@angular/core';
import { VehiculeService } from './providers/vehicule.service'
import { Device } from "./data-management.model";
import { IsActiveMatchOptions } from '@angular/router';
import { NavigationEnd, Router } from "@angular/router";
import { SigninService } from 'src/app/authentification/signin/signin.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-data-management',
    templateUrl: './data-management.component.html',
    styleUrls: ['./data-management.component.css']
})
export class DataManagementComponent implements OnInit {

    vehiculeIcon: Boolean = false;
    groupeIcon: Boolean = false;
    driverIcon: Boolean = false;
    programIcon: Boolean = false;
    gestionDonne: boolean = false;


    unusedDevices: Device[] = [];

    constructor(private vehiculeService: VehiculeService, private router: Router, public signinService: SigninService) {
    }

    ngOnInit() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {            
            this.initRoutes();
        });
        this.loadUnusedDevices();
        this.vehiculeService.getReloadUnusedDevices().subscribe(() => {
            this.loadUnusedDevices();
        });
        this.initRoutes();
    }

    loadUnusedDevices() {
        this.vehiculeService.getUnusedDevices().subscribe(response => {
            this.unusedDevices = response;
        });
    }

    initRoutes() {
        this.gestionDonne = false;
        if (this.router.isActive(this.router.createUrlTree(['/client/dataManagement/groupe']), this.exactMatch)) {
            this.displayGroupeIcon();            
        } else if (this.router.isActive(this.router.createUrlTree(['/client/missions/mission']), this.exactMatch)) {
            this.gestionDonne = true
        } else if (this.router.isActive(this.router.createUrlTree(['/client/missions/planification_mission']), this.exactMatch)) {
            this.gestionDonne = true
        } else if (this.router.isActive(this.router.createUrlTree(['/client/dataManagement/vehicule']), this.exactMatch)) {
            this.displayVehiculeIcon();            
        } else if (this.router.isActive(this.router.createUrlTree(['/client/dataManagement/driver']), this.exactMatch)) {
            this.displayDriverIcon();            
        } else if (this.router.isActive(this.router.createUrlTree(['/client/dataManagement/program']), this.exactMatch)) {
            this.displayProgramIcon();            
        } else if (this.router.isActive(this.router.createUrlTree(['/client/dataManagement/poi']), this.exactMatch)) {
            this.gestionDonne = true
        }
    }


    exactMatch: IsActiveMatchOptions = {
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
    };


    displayVehiculeIcon() {
        this.vehiculeIcon = true;
        this.groupeIcon = false;
        this.driverIcon = false;
        this.programIcon = false;
    }

    displayGroupeIcon() {
        this.vehiculeIcon = false;
        this.groupeIcon = true;
        this.driverIcon = false;
        this.programIcon = false;
    }

    displayDriverIcon() {
        this.vehiculeIcon = false;
        this.groupeIcon = false;
        this.programIcon = false;
        this.driverIcon = true;
    }

    initAllIcons() {
        this.vehiculeIcon = false;
        this.groupeIcon = false;
        this.driverIcon = false;
        this.programIcon = false;
    }

    displayProgramIcon() {
        this.vehiculeIcon = false;
        this.groupeIcon = false;
        this.driverIcon = false;
        this.programIcon = true;
    }

}
